<div class="row justify-content-around mt-5">
    <div class="col-lg-2 mb-3 mb-lg-0">
        <!-- Opret Kunde Knap -->
        <div class="card dashboard-card mb-4">
            <div class="d-flex card-header bg-transparent" [class.disabled]="!departmentSelected()"
                (click)="departmentSelected() && modalService.showCreateCustomer($event)">
                <h5 class="me-auto mt-1">
                    <i class="fa-plus fa-xs fas"></i><i class="fa-user fas"></i> Opret Kunde
                </h5>
            </div>
        </div>
        <!-- Viser til Kunder -->
        <div routerLink="/customers" class="card dashboard-card mb-4">
            <div class="d-flex card-header bg-transparent">
                <h5 class="me-auto mt-1">Kunder</h5>
                <i title="Klik for at navigere til kunder."
                    class="fa-circle-question fa-light info-icon ms-auto mt-2"></i>
            </div>
            <div class="d-flex card-body justify-content-between">
                @if (customerCountResource.error()) {
                Kunne ikke hentes <i class="text-danger fa fa-2x fa-exclamation-triangle"></i>
                } @else if (customerCountResource.isLoading()) {
                <div class="loading-spinner mx-auto" role="status"></div>
                } @else {
                <h1 class="ms-1">{{customerCountResource.value() ?? 0}}</h1>
                <i class="fa fa-users fa-xl me-1 my-auto"></i>
                }
            </div>
        </div>
        <!-- Viser til Synkroniseringer -->
        <div routerLink="/synchronizations" class="card dashboard-card mb-4">
            <div class="d-flex card-header bg-transparent">
                <h5 class="me-auto mt-1">Synkroniseringer</h5>
                <i title="Klik for at navigere til synkroniseringer."
                    class="fa-circle-question fa-light info-icon ms-auto mt-2"></i>
            </div>
            <div class="d-flex card-body justify-content-between">
                @if (synchronizationCountResource.error()) {
                Kunne ikke hentes <i class="text-danger fa fa-2x fa-exclamation-triangle"></i>
                } @else if (synchronizationCountResource.isLoading()) {
                <div class="loading-spinner mx-auto" role="status"></div>
                } @else {
                <h1 class="ms-1">{{synchronizationCountResource.value() ?? 0}}</h1>
                <i class="fa fa-rotate fa-xl me-1 my-auto"></i>
                }
            </div>
        </div>
        <!-- Viser til Adgange -->
        <div routerLink="/resourceaccess" class="card dashboard-card mb-4">
            <div class="d-flex card-header bg-transparent">
                <h5 class="me-auto mt-1">Adgange</h5>
                <i title="Viser afdelinger der har adgang til en eller flere kunder. &#13;Klik for at navigere til adgange."
                    class="fa-circle-question fa-light info-icon ms-auto mt-2"></i>
            </div>
            <div class="d-flex card-body justify-content-between">
                @if (resourceAccessesResource.error()) {
                Kunne ikke hentes <i class="text-danger fa fa-2x fa-exclamation-triangle"></i>
                } @else if (resourceAccessesResource.isLoading()) {
                <div class="loading-spinner mx-auto" role="status"></div>
                }
                @else if ((resourceAccessesResource.value() ?? []).length == 0) {
                <div style="font-weight: bold;">Ingen adgange uddelt</div>
                <i class="fa fa-user-lock fa-xl me-1 mt-3"></i>
                } @else {
                <!-- with padding, 56px makes it similar to the other cards -->
                <div class="d-flex flex-wrap gap-2" style="min-height: 56px; max-width: 250px;">
                    @for (department of resourceAccessesResource.value()!; track $index) {
                    <div class="department-badge" (click)="navigateToResourceAccesses(department.departmentName)"
                        ngbTooltip="{{department.departmentName}}">
                        {{department.departmentCode}}
                    </div>
                    }
                </div>
                <i class="fa fa-user-lock fa-xl me-1 mt-3"></i>
                }
            </div>
        </div>
        <!-- Viser til Sync Fejl (24h) - Only for admins -->
        @if (store.currentUser.get().isAdmin) {
        <div [routerLink]="['/admin-dashboard']" [queryParams]="{timeFilter: '24h'}" class="card dashboard-card">
            <div class="d-flex card-header bg-transparent">
                <h5 class="me-auto mt-1">Sync Fejl (24 timer)</h5>
                <i title="Viser antal sync fejl i de sidste 24 timer. &#13;Klik for at navigere til admin dashboard."
                    class="fa-circle-question fa-light info-icon ms-auto mt-2"></i>
            </div>
            <div class="d-flex card-body justify-content-between">
                @if (syncErrorCountResource.error()) {
                Kunde ikke hentes <i class="text-danger fa fa-2x fa-exclamation-triangle"></i>
                } @else if (syncErrorCountResource.isLoading()) {
                <div class="loading-spinner mx-auto" role="status"></div>
                } @else {
                <h1 class="ms-1">{{syncErrorCountResource.value() ?? 0}}</h1>
                <i class="fa-kit fa-solid-gauge-max-lock fa-xl me-1 my-auto"></i>
                }
            </div>
        </div>
        }
    </div>
    <!-- Info/Seneste fejl -->
    <div class="col-lg-10">
        <!-- user events -->
        <div class="accordion mb-3" id="userEventsAccordion">
            <div class="accordion-item">
                <h2 class="accordion-header">
                    <button class="accordion-button" 
                            [class.collapsed]="!userEventsOpen()"
                            type="button" 
                            (click)="toggleUserEvents()">
                        <h5 class="mb-0">Brugerhændelser</h5>
                    </button>
                </h2>
                <div class="accordion-collapse collapse" [class.show]="userEventsOpen()">
                    <div class="accordion-body p-0">
                        <div class="dashboard-table-container">
                            <table class="table table-striped table-hover mb-0">
                            <thead>
                                <tr>
                                    <th class="timestamp-column">
                                        Tidspunkt
                                    </th>
                                    <th class="severity-column">
                                        Type
                                    </th>
                                    <th>
                                        Beskrivelse
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                @if (userEventsError()) {
                                <tr>
                                    <td colspan="3" class="text-center py-5">
                                        <i class="text-danger fa fa-2x fa-exclamation-triangle mb-2"></i>
                                        <div>Brugerhændelser kunne ikke hentes</div>
                                    </td>
                                </tr>
                                } @else if (userEventsIsLoading()) {
                                <tr>
                                    <td colspan="3" class="text-center py-5">
                                        <div class="loading-spinner mx-auto" role="status"></div>
                                        <div class="mt-2">Indlæser...</div>
                                    </td>
                                </tr>
                                } @else if ((userEventsResource.value() ?? []).length === 0) {
                                <tr>
                                    <td colspan="3" class="text-center py-5 text-muted">
                                        <i class="fa fa-inbox fa-2x mb-2"></i>
                                        <div>Ingen brugerhændelser</div>
                                    </td>
                                </tr>
                                } @else {
                                @for (trace of userEventsResource.value()!; track trace.itemId) {
                                <tr class="dashboard-event-row" (click)="navigateToEvents(trace)">
                                    <td>
                                        {{ trace.timestamp | date: 'HH:mm dd-MM-yyyy' }}
                                    </td>
                                    <td class="icon-column-td" [innerHTML]="trace.severityLevel | severityLevel">
                                    </td>
                                    <td>
                                        <div class="d-flex align-items-center gap-2">
                                            <span class="flex-grow-1">{{ trace.message }}</span>

                                            @if (trace.childCount > 0) {
                                            <span class="details-indicator ms-auto" ngbTooltip="Hændelsen har detaljer">
                                                <i class="fa-list fa-light"></i>
                                                <span>+{{ trace.childCount }}</span>
                                            </span>
                                            }
                                        </div>
                                    </td>
                                </tr>
                                }
                                }
                            </tbody>
                        </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- sync events -->
        @if (recentSyncsResource.error()) {
        <div class="alert alert-danger" role="alert">
            <i class="fa fa-exclamation-triangle me-2"></i>
            Der opstod en fejl ved indlæsning af seneste synkroniseringer
        </div>
        }
        <div class="accordion" id="syncOverviewAccordion">
            <div class="accordion-item">
                <h2 class="accordion-header">
                    <button class="accordion-button"
                            [class.collapsed]="!syncOverviewOpen()"
                            type="button"
                            (click)="toggleSyncOverview()">
                        <h5 class="mb-0">Synkronisering Overblik, 24 timer ({{ syncTimeRangeText() }})</h5>
                    </button>
                </h2>
                <div class="accordion-collapse collapse" [class.show]="syncOverviewOpen()">
                    <div class="accordion-body p-0">
                        <div class="dashboard-table-container">
                            <table class="table table-striped table-hover mb-0">
                            <thead>
                                <tr>
                                    <th class="timestamp-column">
                                        Seneste Synk.
                                    </th>
                                    <th class="result-column">
                                        Antal
                                    </th>
                                    <th class="flex-fill">
                                        Synkronisering
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                @if (recentSyncsResource.isLoading()) {
                                <tr>
                                    <td colspan="3" class="text-center py-5">
                                        <div class="loading-spinner mx-auto" role="status"></div>
                                        <div class="mt-2">Indlæser...</div>
                                    </td>
                                </tr>
                                } @else if ((recentSyncsResource.value() ?? []).length === 0) {
                                <tr>
                                    <td colspan="3" class="text-center py-5 text-muted">
                                        <i class="fa fa-inbox fa-2x mb-2"></i>
                                        <div>Ingen synkroniseringer</div>
                                    </td>
                                </tr>
                                } @else {
                                @for (sync of recentSyncsResource.value()!; track sync.synchronizationId) {
                                <tr class="dashboard-event-row" (click)="navigateToSync(sync)">
                                    <td>
                                        {{ sync.latestActivity | date: 'HH:mm dd-MM-yyyy' }}
                                    </td>
                                    <td class="result-column-td">
                                        <a [routerLink]="['/synchronization', sync.synchronizationId]" 
                                           [queryParams]="{ status: 'finished' , time: '24h' }"
                                           class="me-2 clickable-icon text-decoration-none"
                                           [class.sync-success]="sync.successCount > 0"
                                           [class.text-secondary]="!sync.successCount"
                                           ngbTooltip="Naviger til færdige synkroniseringer"
                                           placement="top"
                                           (click)="$event.stopPropagation()">
                                            <i class="fa fa-rotate"></i> {{ sync.successCount || 0 }}
                                        </a>
                                        <a [routerLink]="['/synchronization', sync.synchronizationId]" 
                                           [queryParams]="{ status: 'warning' , time: '24h' }"
                                           class="me-2 clickable-icon text-decoration-none"
                                           [class.sync-warning]="sync.warningCount > 0"
                                           [class.text-secondary]="!sync.warningCount"
                                           ngbTooltip="Naviger til synkroniseringer med advarsler"
                                           placement="top"
                                           (click)="$event.stopPropagation()">
                                            <i class="fa fa-exclamation-triangle"></i> {{ sync.warningCount || 0 }}
                                        </a>
                                        <a [routerLink]="['/synchronization', sync.synchronizationId]" 
                                           [queryParams]="{ status: 'failed' , time: '24h' }"
                                           class="clickable-icon text-decoration-none"
                                           [class.sync-error]="sync.failedCount > 0"
                                           [class.text-secondary]="!sync.failedCount"
                                           ngbTooltip="Naviger til fejlede synkroniseringer"
                                           placement="top"
                                           (click)="$event.stopPropagation()">
                                            <i class="fa fa-triangle-exclamation"></i> {{ sync.failedCount || 0 }}
                                        </a>
                                    </td>
                                    <td>
                                        <strong>{{ sync.syncName }}</strong>
                                        <span class="text-muted ms-2">(Kunde: {{ sync.customerName }} [{{ sync.customerId }}] - Regnskab: {{ sync.companyName }} [{{ sync.companyId }}])</span>
                                    </td>
                                </tr>
                                }
                                }
                            </tbody>
                        </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>